export default __webpack_public_path__ + "static/media/phase4-bg.85e7ff64.svg";